export const XD_MAIN_ORDER = 1;
export const XD_FULL_STOCK_ORDER = 2;
export const XD_PARTIAL_ORDER = 3;
